import gql from "graphql-tag";

// // // //

export const loginUserMutation = gql`
    mutation($input: EmailAuth!) {
        login(input: $input)
    }
`;
